var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{staticClass:"mt-0",attrs:{"id":"radio-lang-select","hide-details":"","row":""},model:{value:(_vm.locale),callback:function ($$v) {_vm.locale=$$v},expression:"locale"}},_vm._l((_vm.locales),function(loc){return _c('v-radio',{key:loc,attrs:{"on-icon":"done","label":_vm.$t(`i18n.${loc}`),"value":loc,"id":`locales-${loc}`}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }